$(document).ready(function () {
  function cleanupAriaCurrent() {
    $('.crush-perfume-section .slick-dots button').each(function () {
        const $btn = $(this);
        const isActive = $btn.parent().hasClass('slick-active');

        if (isActive) {
        $btn.attr('aria-current', 'true');
        } else {
        $btn.removeAttr('aria-current');
        }

        $btn.removeAttr('aria-selected');
    });
  }


  cleanupAriaCurrent();

  setTimeout(cleanupAriaCurrent, 500);
  setTimeout(cleanupAriaCurrent, 1000);

  $('.product-display').each(function (index) {
    const $carousel = $(this);
    const ariaLabel = $carousel.attr('aria-label') || '';
    const productTitle = ariaLabel.replace('Product images for ', '') || 'product';

    // Initialize Slick slider
    $carousel.slick({
      dots: true,
      infinite: false,
      autoplay: false,
      loop: true,
      prevArrow: `<button type="button" aria-disabled="true" class="slick-arrow slick-prev" aria-label="Previous ${productTitle} image"><svg xmlns="http://www.w3.org/2000/svg" width="10.014" height="15.738" viewBox="0 0 10.014 15.738" aria-hidden="true">
                    <path id="Path_753" data-name="Path 753" d="M22848-22416.84l7.85,7.193-7.85,7.064" transform="translate(-22847.324 22417.576)" fill="none" stroke="#fff" stroke-width="2"/>
                  </svg>
                  <span class="screen-reader-only">Previous</span>
                  </button>`,
      nextArrow: `<button type="button" aria-disabled="true" class="slick-arrow slick-next" aria-label="Next ${productTitle} image"><svg xmlns="http://www.w3.org/2000/svg" width="10.014" height="15.738" viewBox="0 0 10.014 15.738" aria-hidden="true">
                    <path id="Path_753" data-name="Path 753" d="M22848-22416.84l7.85,7.193-7.85,7.064" transform="translate(-22847.324 22417.576)" fill="none" stroke="#fff" stroke-width="2"/>
                  </svg>
                  <span class="screen-reader-only">Next</span>
                  </button>`,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            arrows: true,
            dots: true,
          },
        },
      ],
    });

    $carousel.on('init afterChange', function (event, slick, currentSlide) {
      const slideIndex =
        typeof currentSlide !== 'undefined' ? currentSlide : slick ? slick.currentSlide : 0;
      const $track = $carousel.find('.slick-track');
      const $slides = $carousel.find('.slick-slide');
      const $dots = $carousel.find('.slick-dots button');

      let $announcer = $carousel.find('.slick-announcer');
      if (!$announcer.length) {
        $announcer = $(
          '<div class="slick-announcer" aria-live="assertive" aria-atomic="true" style="position: absolute; width: 1px; height: 1px; padding: 0; margin: -1px; overflow: hidden; clip: rect(0, 0, 0, 0); white-space: nowrap; border: 0;"></div>'
        );
        $carousel.append($announcer);
      }

      const $currentSlide = $slides.eq(slideIndex);
      const currentImageLabel = $currentSlide.find('img').attr('alt');

      const $mainSlide = $carousel.closest('.crush-slide');
      const productTitle = $mainSlide.find('.crush-title').text().trim();

      if (event.type === 'afterChange') {
        $announcer.empty();
        setTimeout(function () {
          const announcement = productTitle
            ? `${productTitle}, ${currentImageLabel || 'image ' + (slideIndex + 1)}`
            : currentImageLabel || 'image ' + (slideIndex + 1);
          $announcer.text(announcement);
        }, 150);
      }

      $track.attr({
        'aria-atomic': 'false',
        'aria-live': 'off',
      });
      $slides.each(function () {
        const $slide = $(this);
        const isVisible = $slide.hasClass('slick-active');
        $slide.attr({
          role: 'group',
          'aria-hidden': isVisible ? 'false' : 'true',
          tabindex: isVisible ? '0' : '-1',
        });
      });

      const $prevBtn = $carousel.find('.slick-prev');
      const $nextBtn = $carousel.find('.slick-next');
      const totalSlides = $slides.length;

      if ($prevBtn.length) {
        const isDisabled = slideIndex === 0;
        $prevBtn.attr('tabindex', isDisabled ? '-1' : '0');
        setTimeout(() => $prevBtn.removeAttr('aria-disabled').prop('disabled', false), 50);
      }
      if ($nextBtn.length) {
        const isDisabled = slideIndex >= totalSlides - 1;
        $nextBtn.attr('tabindex', isDisabled ? '-1' : '0');
        setTimeout(() => $nextBtn.removeAttr('aria-disabled').prop('disabled', false), 50);
      }

      $dots.each(function (dotIdx) {
        const isActive = dotIdx === slideIndex;
        const $dot = $(this);
        let label = $dot.attr('aria-label') || '';
        if (label.match(/slide/i)) {
          label = label.replace(/slide/i, 'image');
          $dot.attr('aria-label', label);
        } else if (!label) {
          $dot.attr('aria-label', `Go to image ${dotIdx + 1}`);
        }

        if (isActive) {
          $dot.attr('aria-current', 'true');
          $dot.removeAttr('aria-selected');
        } else {
          $dot.removeAttr('aria-current');
          $dot.removeAttr('aria-selected');
        }

        $dot.attr('tabindex', isActive ? '0' : '-1');
      });

      setTimeout(cleanupAriaCurrent, 100);
    });
  });
});